import React from 'react'
import NewsLetter from './newsletter/NewsLetter.jsx'
import Advert from './advertPage/Advert.jsx'
import Description from './description/Description.jsx'
import Details from './details/Details.jsx'
import GetInTouch from './getInTouch/GetInTouch.jsx'
import ShowCase from './heroPage/ShowCase'
import Offer from './offer/Offer.jsx'
import OnTheGo from './onTheGo/OnTheGo.jsx'
import Footer from '../footer/Footer'
import Navbar from '../navbar/Navbar.jsx'


function Index() {
    return (
        <div>
            <Navbar />
            <ShowCase />
            <Advert />
            <Details />
            <Description />
            <Offer />
            <OnTheGo />
            <NewsLetter />
            <GetInTouch />
            <Advert />
            <Footer />
            
        </div>
    )
}

export default Index
